export default __webpack_public_path__ + "static/media/pour-wine.f73ad152.jpg";